module.exports = __webpack_public_path__ + "img/appstore.b36f652.png";